import {ClientThemeName} from "@sparkware/uc-sdk-core";

export class ThemeName {
    constructor(public readonly forClient: string,
                public readonly forWidgets: ClientThemeName) {
    }

    public static Casino888 = new ThemeName('casino888', ClientThemeName.Casino888);
    public static Casino888Cip = new ThemeName("casino888/cip", ClientThemeName.Casino888);
    public static Casino888Cis = new ThemeName("casino888/cis", ClientThemeName.Casino888);
    public static Casino777 = new ThemeName("casino777", ClientThemeName.Casino777);

    public static Harrahs = new ThemeName("harrahs", ClientThemeName.Harrahs)
    public static Wsop = new ThemeName('wsop', ClientThemeName.WSOP);
    public static WsopCip = new ThemeName("wsop/cip", ClientThemeName.WSOP);
    public static BallysDover = new ThemeName("ballysdover", ClientThemeName.Ballysdover);
    public static Delawarepark = new ThemeName("delawarepark", ClientThemeName.Delawarepark);
    public static Harrington = new ThemeName("harrington", ClientThemeName.Harrington);
    public static SI = new ThemeName('si', ClientThemeName.SI); //sports illustrator
    public static SICis = new ThemeName('si/cis', ClientThemeName.SI);
    public static MrGreen = new ThemeName("mrgreen", ClientThemeName.MrGreen);
    public static MrGreenCis = new ThemeName("mrgreen/cis", ClientThemeName.MrGreen);
    public static MrGreenCip = new ThemeName("mrgreen/cip", ClientThemeName.MrGreen);
}